import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { cloneDeep, isEmpty, keys, pickBy, startCase, orderBy } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';
import useWindowSize from '../../../hooks/useWindowSize';
import queryString from 'query-string';

import { array } from 'prop-types';
import { isJson } from '../../../helpers/json';

import {
    Grid,
    GridNoRecords,
    GridToolbar,
    GridColumn as Column,
} from '@progress/kendo-react-grid';
import { Operators, TextFilter, NumericFilter, DateFilter, BooleanFilter } from '@progress/kendo-react-data-tools';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { process as kendoProcess } from '@progress/kendo-data-query';

import BobTableContextMenu from '../../../components/BobTableContextMenu';
import BobLoadingMask from '../../../components/BobLoadingMask';
import CreateClientModal from '../CompanyPage/CreateClientModal';
import EditClientModal from '../CompanyPage/EditClientModal';
import DeleteClientModal from '../CompanyPage/DeleteClientModal';
import BobModal from '../../../components/BobModal';
import ColumnFilterMenu from '../../../components/ColumnFilterMenu';
import FilterPanel from '../../../components/K2AFilterControl/FilterPanel';

import {dashboardContent} from '../../../localization/en-us/dashboardContent';
import { calculateMinColumnWidths } from '../../../helpers/calculateMinColumnWidths';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import FormulaGridColumnModal from '../../../components/FormulaGridColumnModal';
import BobConditionalFormattingModal from '../Modals/BobConditionalFormattingModal';


import * as BobActions from '../../../actions/bobActions';
import * as ConfigurationActions from '../../../actions/configurationActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './Table.module.css';

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const initialDataState = {
    sort:   [],
    take:   10,
    skip:   0,
    filter: initialDataStateFilter
};

const styleMap = {
    'yellow-cell': {background: '#ffefaf',color: '#783f05'},
    'green-cell':  {background: '#b7e1cd',color: '#274e13'},
    'grey-cell':   {background: '#d9d9d9',color: '#434343'},
    'red-cell':    {background: '#fcd6d6',color: '#85200c'}
};

const ClientsTable = ({
    activeNavCompany,
    bobLoading,
    clientFilters,
    clients,
    clientsMeta,
    configurations,
    companies,
    currentUser,
    customAttributes,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    exportRawData,
    fetchDashboardData,
    fetchNavClients,
    fetchNavSites,
    fetchSingleClient,
    history,
    resetNavOptions,
    saveConfiguration,
    setNavCompany,
    setNavClient,
    setWorkBookMode,
    targetNavCompany,
    totalsData,
    createClientModalOpen,
    subscribeToAlertsModalOpen,
    editClientModalOpen,
    deleteClientModalOpen,
    handleToggleCreateClientModal,
    handleToggleSubscribeToAlertsModal,
    handleToggleEditClientModal,
    handleToggleDeleteClientModal,
    refreshTab,
    setExportRawData,
    setRefreshTab,
    setTableProps,
    searchTerm,
    updateAllConfigurations,
    updateCoreConfigurations,
    updateConfiguration,
    userId,
    workbookModeEnabled,
    ...props
}) => {
    const defaultColumnList = [
        {
            title:             dashboardContent.client,
            field:             'clientName',
            id:                'clientColumn',
            width:             350,
            show:              true,
            hidden:            false,
            filter:            'text',
            sortable:          true,
            filterable:        workbookModeEnabled,
            locked:            false,
            reorderable:       false,
            orderIndex:        0,
            minResizableWidth: 400,
            primaryKey:        true
        },
        {
            title:       dashboardContent.businessType,
            field:       'businessTypeName',
            width:       350,
            show:        true,
            hidden:      false,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true,
            orderIndex:  1
        },
        {
            title:       dashboardContent.sites,
            field:       'siteCount',
            width:       200,
            show:        true,
            hidden:      false,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true,
            orderIndex:  2
        },
        {
            title:       dashboardContent.faults,
            field:       'totalFaultCount',
            width:       200,
            show:        true,
            hidden:      false,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true,
            orderIndex:  3
        },
        {
            title:       dashboardContent.high,
            field:       'highFaultCount',
            width:       200,
            show:        true,
            hidden:      false,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true,
            orderIndex:  4
        },
        {
            title:       dashboardContent.medium,
            field:       'mediumFaultCount',
            width:       200,
            show:        true,
            hidden:      false,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true,
            orderIndex:  5
        },
        {
            title:       dashboardContent.low,
            field:       'lowFaultCount',
            width:       200,
            show:        true,
            hidden:      false,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true,
            orderIndex:  6
        },
        {
            title:       '',
            field:       '',
            locked:      true,
            sortable:    false,
            filterable:  false,
            width:       75,
            show:        true,
            hidden:      true,
            reorderable: false,
            actionCell:  true,
            orderIndex:  1000
        }
    ];

    const [sortFilter] = useState('');
    const [typeFilters, setTypeFilters] = useState([]);
    const [priorityFilters, setPriorityFilters] = useState([]);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [client, setClient] = useState(null);
    const [dataState, setDataState] = useState(initialDataState);
    const [clientColumnWidth, setClientColumnWidth] = useState(350);
    const [tableData, setTableData] = useState([]);

    const [columns, setColumns] = useState(defaultColumnList);
    const [hasInitialized, setHasInitialized] = useState(false);
    const [gridFilterText, setGridFilterText] = useState('');
    const [gridFields, setGridFields] = useState([]);
    const [gridFilter, setGridFilter] = useState(initialDataStateFilter);

    const [showModal, setShowModal] = useState(false);
    const [formulaCellModalOpen, setFormulaCellModalOpen] = useState(false);

    const [formatKey, setFormatKey] = useState('');
    const [formatType, setFormatType] = useState('');
    const [formatList, setFormatList] = useState([]);
    const [formatObj, setFormatObj] = useState({});

    const [formulaColumns, setFormulaColumns] = useState([]);
    const [formulaColumnIndex, setFormulaColumnIndex] = useState(0);
    const [formulaValues, setFormulaValues] = useState(null);
    const [currentFormula, setCurrentFormula] = useState(null);
    
    const queryValues = queryString.parse(history.location.search);
    const companyId = queryValues.company;
    
    const isInitialMount = useRef(true);
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);
    const _export = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const colWidth = calculateMinColumnWidths(defaultColumnList.filter(c => c.show), gridDivRef.current.offsetWidth, 'clientName', 350, true);
        setClientColumnWidth(colWidth);
        defaultColumnList.find(c => c.id === 'clientColumn').width = colWidth;
        defaultColumnList.find(c => c.actionCell).orderIndex = 1000;
        setColumns(defaultColumnList);
    }, [activeNavCompany.id]);

    useEffect(() => {
        if (exportRawData) {
            handleExport();
            setExportRawData(false);
        }
    }, [exportRawData]);

    useEffect(() => {
        setDataState({ ...dataState, filter: gridFilter });
    }, [gridFilter]);

    useEffect(() => {
        if (formulaValues) {
            addFormulaColumn(formulaValues);
        }
    }, [formulaValues]);

    useEffect(() => {
        const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');
        setTableData(clients);

        if (!isEmpty(tableConfiguration)) {
            if (!isEmpty(tableConfiguration.viewData.formulaColumns)) {
                tableConfiguration.viewData.formulaColumns.forEach(item => {
                    const dataSet = addFormulaToGridDataSet(item, item.fieldName, clients);
                    setTableData(dataSet);
                });
            }
        }

    }, [clients]);

    useEffect(() => {
        const init = async () => {
            if (!hasInitialized) return;
            const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');

            if (tableConfiguration) {
                if (formulaColumns === tableConfiguration.viewData.formulaColumns) return;
                dataState.columns = columns;
                tableConfiguration.viewData = JSON.stringify({ 
                    dataState:           dataState, 
                    formatObj:           formatObj, 
                    formulaColumns:      formulaColumns, 
                    ownerId:             currentUser.id,
                    workbookModeEnabled: workbookModeEnabled 
                });
                await updateConfiguration(tableConfiguration.id, tableConfiguration, true);
                updateCoreConfigurations(tableConfiguration.id, tableConfiguration);
            } else {
                let body = {
                    name:       'Dashboard Company Client Table Configuration',
                    viewKey:    'Dashboard|CompanyClientTable',
                    entityId:   activeNavCompany.id,
                    entityName: activeNavCompany.name,
                    isDefault:  false,
                    viewData:   JSON.stringify({ 
                        dataState: { 
                            ...dataState, 
                            workbookModeEnabled: workbookModeEnabled,
                            columns:             columns 
                        }, 
                        formatObj:      formatObj, 
                        formulaColumns: formulaColumns, 
                        ownerId:        currentUser.id }),
                    sharedEmails: []
                };
                const id = await saveConfiguration(userId, body, true);
                if (id) {
                    body.id = id;
                    let activeState = cloneDeep(body.viewData);
                    body.viewData = JSON.parse(activeState);
                    updateCoreConfigurations(id, body);
                }
            }
        };

        if (!isEmpty(activeNavCompany)) init();
    }, [formulaColumns]);

    useEffect(() => {
        const init = async () => {
            const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');
            if (tableConfiguration) {
                if (dataState === tableConfiguration.viewData.dataState) return;
                dataState.columns = columns;
                tableConfiguration.viewData = JSON.stringify({ 
                    dataState:           dataState, 
                    formatObj:           formatObj, 
                    formulaColumns:      formulaColumns, 
                    ownerId:             currentUser.id,
                    workbookModeEnabled: workbookModeEnabled 
                });
                await updateConfiguration(tableConfiguration.id, tableConfiguration, true);
                updateCoreConfigurations(tableConfiguration.id, tableConfiguration);
            } else {
                let body = {
                    name:       'Dashboard Company Client Table Configuration',
                    viewKey:    'Dashboard|CompanyClientTable',
                    entityId:   activeNavCompany.id,
                    entityName: activeNavCompany.name,
                    isDefault:  false,
                    viewData:   JSON.stringify({ 
                        dataState: { 
                            ...dataState,
                            workbookModeEnabled: workbookModeEnabled, 
                            columns:             columns 
                        }, 
                        formatObj:      formatObj, 
                        formulaColumns: formulaColumns, 
                        ownerId:        currentUser.id 
                    }),
                    sharedEmails: []
                };
                const id = await saveConfiguration(userId, body, true);
                if (id) {
                    body.id = id;
                    let activeState = cloneDeep(body.viewData);
                    body.viewData = JSON.parse(activeState);
                    updateCoreConfigurations(id, body);
                }
            }
        };
        if (dataState && !isEmpty(configurations) && dataState !== initialDataState) {
            init();
        }
    }, [dataState]);

    useEffect(() => {
        const columnList = columns.filter(col => !col.actionCell && !col.hidden).map(column => {
            const filterType = column.filter === 'text' ? TextFilter : column.filter === 'numeric' ? NumericFilter : column.filter === 'date' ? DateFilter : BooleanFilter;
            const operatorList = column.filter === 'text' ? Operators.text : column.filter === 'numeric' ? Operators.numeric : column.filter === 'date' ? Operators.date : Operators.boolean;
            return {
                name:       column.field,
                label:      column.title ? column.title : column.name,
                filter:     filterType,
                operators:  operatorList,
                actionCell: column.actionCell
            };
        });
        setGridFields(columnList);
    }, [columns]);

    useEffect(() => {
        if (!isEmpty(configurations) && !hasInitialized) {
            let tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');
            if (!isEmpty(tableConfiguration)) {
                setDataState({...dataState, filter: tableConfiguration.viewData.dataState.filter, sort: tableConfiguration.viewData.dataState.sort, take: tableConfiguration.viewData.dataState.take });
                setWorkBookMode(tableConfiguration.viewData.workbookModeEnabled);

                if (!tableConfiguration.viewData.workbookModeEnabled && tableConfiguration.viewData.dataState.filter !== initialDataStateFilter) {
                    tableConfiguration.viewData.dataState.filter = initialDataStateFilter;
                }
                if (typeof (tableConfiguration.viewData) === 'string') {
                    tableConfiguration.viewData = JSON.parse(tableConfiguration.viewData);
                }
                if (tableConfiguration.viewData.dataState.columns) {
                    const columnArray = tableConfiguration.viewData.dataState.columns.map((c) => {
                        c.width = c.field === 'clientName' ? 350 : c.width;
                        if (c.field.toLowerCase().includes('faultcount')) {
                            c.hidden = !dashboardIsCurrentTimeStamp;
                        }
                        else {
                            c.hidden = false;
                        }
                        return c;
                    });
                    const colWidth = calculateMinColumnWidths(columnArray.filter(c => c.show), gridDivRef.current.offsetWidth, 'clientName', 350, true);
                    setClientColumnWidth(colWidth);
                    columnArray.find(c => c.id === 'clientColumn').width = colWidth;
                    columnArray.find(c => c.actionCell).orderIndex = 1000;
                    setColumns(columnArray);
                }

                if (tableConfiguration.viewData.formatObj) {
                    setFormatObj(tableConfiguration.viewData.formatObj);
                }

                if (tableConfiguration.viewData.formulaColumns) {
                    setFormulaColumns(tableConfiguration.viewData.formulaColumns);
                }

                setHasInitialized(true);
            }
        }
    }, [configurations]);

    useEffect(() => {
        if (!isEmpty(customAttributes['Client'])) {
            const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');
            if (!isEmpty(tableConfiguration)) {
                if (!isEmpty(tableConfiguration.viewData.dataState.columns)) {
                    tableConfiguration.viewData.dataState.columns.find(c => c.actionCell).orderIndex = 1000;
                    setColumns(tableConfiguration.viewData.dataState.columns);
                }

                if (!isEmpty(tableConfiguration.viewData.formatObj)) {
                    setFormatObj(tableConfiguration.viewData.formatObj);
                }

                return;
            }
            const selectedAttributes = customAttributes['Client'];
            let updatedColumns = [...columns];
            selectedAttributes.forEach(item => {
                const attrColumn = updatedColumns.find(c => c.field === item.name);
                if (!attrColumn) {
                    updatedColumns.splice(1, 0, {
                        field:      item.name,
                        title:      startCase(item.name),
                        width:      200,
                        locked:     false,
                        sortable:   true,
                        filterable: true,
                        filter:     item.dataType || 'text',
                        show:       false,
                        hidden:     false,
                        orderIndex: updatedColumns.length - 1
                    });
                }
            });
            updatedColumns.find(c => c.actionCell).orderIndex = 1000;
            setColumns(updatedColumns);
        }
    }, [customAttributes]);

    useEffect(() => {
        if (!isEmpty(columns)) {
            let columnList = [];
            const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');
            if (!isEmpty(tableConfiguration)) {
                const configObject = { ...tableConfiguration };
                if (typeof (configObject.viewData) === 'string') {
                    configObject.viewData = JSON.parse(configObject.viewData);
                }
                if (!isEmpty(configObject.viewData.dataState.columns)) {
                    columnList = [...configObject.viewData.dataState.columns];
                } else {
                    let updatedColumns = [...columns];
                    if (!isEmpty(customAttributes)) {
                        const selectedAttributes = customAttributes['Client'];
                        selectedAttributes.forEach(item => {
                            const attrColumn = updatedColumns.find(c => c.field === item.name);
                            if (!attrColumn) {
                                updatedColumns.splice(1, 0, {
                                    field:      item.name,
                                    title:      startCase(item.name),
                                    width:      200,
                                    locked:     false,
                                    sortable:   true,
                                    filterable: true,
                                    filter:     item.dataType || 'text',
                                    show:       false,
                                    hidden:     false,
                                    orderIndex: updatedColumns.length - 1
                                });
                            }
                        });
                    }

                    columnList = [...updatedColumns];
                }
            } else {
                let updatedColumns = [...columns];
                if (!isEmpty(customAttributes)) {
                    const selectedAttributes = customAttributes['Client'];
                    selectedAttributes.forEach(item => {
                        const attrColumn = updatedColumns.find(c => c.field === item.name);
                        if (!attrColumn) {
                            updatedColumns.splice(1, 0, {
                                field:      item.name,
                                title:      startCase(item.name),
                                width:      200,
                                locked:     false,
                                sortable:   true,
                                filterable: true,
                                filter:     item.dataType || 'text',
                                show:       false,
                                hidden:     false,
                                orderIndex: updatedColumns.length - 1
                            });
                        }
                    });
                }

                columnList = [...updatedColumns];
            }

            const columnArray = orderBy(columnList, 'orderIndex', 'asc').map((c) => {
                c.width = c.field === 'clientName' ? 350 : c.width;
                if (c.field.toLowerCase().includes('faultcount')) {
                    c.hidden = !dashboardIsCurrentTimeStamp;
                }
                else {
                    c.hidden = false;
                }
                return c;
            });
            const colWidth = calculateMinColumnWidths(columnArray.filter(c => c.show && !c.hidden), gridDivRef.current.offsetWidth, 'clientName', 350, true);
            setClientColumnWidth(colWidth);
            columnArray.find(c => c.id === 'clientColumn').width = colWidth;
            columnArray.find(c => c.actionCell).orderIndex = 1000;
            setColumns(columnArray);
        }
    }, [windowSize, dashboardIsCurrentTimeStamp]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            initialDataState.filter = initialDataStateFilter;

            setGridFilter(initialDataStateFilter);
            setGridFilterText('');

            if (hasInitialized) {
                const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');
                if (!isEmpty(tableConfiguration)) {
                    const viewData = isJson(tableConfiguration.viewData) ? JSON.parse(tableConfiguration.viewData) : tableConfiguration.viewData;
                    viewData.dataState.filter = initialDataStateFilter;
                    setDataState({...dataState, filter: viewData.dataState.filter, sort: viewData.dataState.sort, take: viewData.dataState.take });
                } else {
                    setDataState(initialDataState);
                }
            }
        }
        const columnList = columns.map(c => {
            c.filterable = c.actionCell ? false : workbookModeEnabled;
            return c;
        });
        setColumns(columnList);
    }, [workbookModeEnabled]);

    useEffect(() => {
        setSkip(0);
        setTake(10);
    }, [companyId]);

    useEffect(() => {
        if (clientFilters.type || Object.values(clientFilters.priority).includes(true)) {
            const typeFilters = clientFilters.type.map(filter => filter.id);
            const priorityFilters = keys(pickBy(clientFilters.priority));

            setTypeFilters(typeFilters);
            setPriorityFilters(priorityFilters);
        }
    }, []);

    useEffect(() => {
        if (activeNavCompany && activeNavCompany.name && isEmpty(clients)) {
            initializeFetch();
        }
    }, [activeNavCompany]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if ((clientFilters.type || Object.values(clientFilters.priority).includes(true))) {
                if (!isEmpty(targetNavCompany) && !isEmpty(clientsMeta)) {
                    initializeFetch();
                }
            } else {
                const init = async () => {
                    initializeFetch();
                };
                
                if (activeNavCompany.id && !isEmpty(clients)) init();
            }
        }
    }, [clientFilters, dashboardStartTimeStamp, dashboardEndTimeStamp, searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            let page = 1;
            
            if ( skip && take ) {
                page = skip / take + 1;
            }

            if (sortFilter) {
                await fetchDashboardData(activeNavCompany.id, 'CompanyClient', { sort: sortFilter, searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            } else {
                await fetchDashboardData(activeNavCompany.id, 'CompanyClient', { sort: 'default^desc', searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            }

            setRefreshTab();
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const initializeFetch = async () => {
        setSkip(0);

        const typeFilters = clientFilters.type.map(filter => filter.id);
        const priorityFilters = keys(pickBy(clientFilters.priority));

        setTypeFilters(typeFilters);
        setPriorityFilters(priorityFilters);

        if (!isEmpty(searchTerm)) {
            setTableProps({
                search: searchTerm,
                sort:   sortFilter
            });
        }
        
        if (sortFilter) {
            await fetchDashboardData(activeNavCompany.id, 'CompanyClient', { sort: sortFilter, limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        } else {
            await fetchDashboardData(activeNavCompany.id, 'CompanyClient', { sort: 'default^desc', limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        }
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const handleNameNavigation = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `client?client=${dataItem.clientId}&company=${queryValues.company}`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/client';

        const queryValues = queryString.parse(history.location.search);
        queryValues.company = dataItem.companyId;
        queryValues.client = dataItem.clientId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        } else {
            resetNavOptions('client');
        }

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);

        await fetchSingleClient(queryValues);
    };

    const getStyle = (condition) => {
        if (!condition) {
            return '';
        }
        else if (condition.indexOf('Yellow') !== -1) {
            return 'yellow-cell';
        }
        else if (condition.indexOf('Green') !== -1) {
            return 'green-cell';
        }
        else if (condition.indexOf('Grey') !== -1) {
            return 'grey-cell';
        }
        else if (condition.indexOf('Red') !== -1) {
            return 'red-cell';
        }
        else return '';
    };

    const getBoolean = (val) => {
        return String(val)?.toLowerCase() === 'true';
    };

    const parseCondition = (conditions, value, datatype) => {
        let style = '';
        if (datatype === 'numeric') {
            conditions.forEach(c => {
                if (c.operator === 'Greater Than') {
                    if (Number(value) > c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Less Than') {
                    if (Number(value) < c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (Number(value) === c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Between') {
                    if ((Number(value) >= c.field1 && Number(value) <= c.field2) || (Number(value) <= c.field1 && Number(value) >= c.field2)) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else if (datatype === 'boolean') {
            conditions.forEach(c => {
                if (c.operator === 'Equals') {
                    if (getBoolean(value) === getBoolean(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not Equal') {
                    if (getBoolean(value) !== getBoolean(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else if (datatype === 'date') {
            conditions.forEach(c => {
                if (c.operator === 'Greater Than') {
                    if (new Date(value).getTime() > new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Less Than') {
                    if (new Date(value).getTime() < new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (new Date(value).getTime() === new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Between') {
                    if ((new Date(value).getTime() >= new Date(c.field1).getTime() && new Date(value).getTime() <= new Date(c.field2).getTime()) ||
                        (new Date(value).getTime() <= new Date(c.field1).getTime() && new Date(value).getTime() >= new Date(c.field2).getTime())) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else if (datatype === 'string' || datatype === 'text') {
            conditions.forEach(c => {
                if (c.operator === 'Contains') {
                    if (value.indexOf(c.field1) !== -1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not contain') {
                    if (value.indexOf(c.field1) === -1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (value === c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not Equal') {
                    if (value !== c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Starts with') {
                    if (value.startsWith(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Ends with') {
                    if (value.endsWith(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        return style;
    };

    const nameCell = props => {
        const { dataItem, field } = props;
        const conditions = formatObj[field];
        let className = '';
        const datatype = columns.filter(c => c.field === field)[0].filter;
        if (conditions && dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) {
            className = parseCondition(conditions, dataItem[field], datatype);
        }

        return (
            <td className={`${props.className} ${className}`} style={props.style}>
                <Link
                    to={handleNameNavigation(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const handleEditClient = (clientData) => {
        setClient(clientData);
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48&company=${activeNavCompany.id}&entityId=${clientData.clientId}&entityType=client&parentId=7e71f5d4-9fbf-4710-8601-e1f11e681479`,
                state:    { 'returnUrl': `/v2/dashboard/company?appId=${bob.key}&childId=ccb00d85-7b0c-44ba-bd0e-db216ef1ee46&company=${activeNavCompany.id}&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4` }
            })
            :
            handleToggleEditClientModal(true);
    };

    const fetchClientDataForDelete = (clientData) => {
        setClient(clientData);
        handleToggleDeleteClientModal(true);
    };

    const fetchClientDataForAlerts = (clientData) => {
        clientData.name = clientData.clientName;
        clientData.id = clientData.clientId;

        setClient(clientData);
        handleToggleSubscribeToAlertsModal(true);
    };

    const fetchClients = async body => {
        await setNavClient({
            name: body.name,
            id:   body.id
        });

        setSkip(0);

        await fetchDashboardData(activeNavCompany.id, 'CompanyClient', { sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const fetchUpdatedClientList = async () => {
        await fetchNavClients(activeNavCompany.id);

        setSkip(0);

        await fetchDashboardData(activeNavCompany.id, 'CompanyClient', { sort: 'default^desc', searchFilter: searchTerm, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    entityData={props.dataItem}
                    onDelete={(entityData) => {fetchClientDataForDelete(entityData);}}
                    onFetch={(entityData) => handleEditClient(entityData)}
                    onSubscribeAlerts={(entityData) => { fetchClientDataForAlerts(entityData);}}
                />
            </td>
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }

        const { dataItem, field } = props;
        const conditions = formatObj[field];
        let className = '';
        const datatype = columns.filter(c => c.field === field)[0].filter;
        if (conditions && dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) {
            className = parseCondition(conditions, dataItem[field], datatype);
        }


        return (
            <td className={`${props.className} ${className}`} style={props.style}>
                <img className={ props.dataItem[props.field] > 0 ? classes.IconImage: classes.IconImageGray} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const dataCell = props => {
        const { dataItem, field } = props;
        const conditions = formatObj[field];
        let className = '';
        const datatype = columns.filter(c => c.field === field)[0].filter;
        if (conditions && dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) {
            className = parseCondition(conditions, dataItem[field], datatype);
        }


        return (
            <td className={`${props.className} ${className}`} style={props.style}>
                {props.dataItem[props.field]}
            </td>
        );
    };

    const updateColumns = menuColumns => {
        
        const columnArray = columns.map((c) => {
            const updatedColumn = menuColumns.find(mc => mc.field === c.field);
            if (updatedColumn && updatedColumn.field.toLowerCase().includes('faultcount')) {
                if (dashboardIsCurrentTimeStamp) {
                    c.hidden = false;
                }
                else {
                    c.hidden = true;
                }
                c.show = updatedColumn.show;
            }
            else if (updatedColumn) {
                if (!c.hidden) {
                    c.show = updatedColumn.show;
                }
            }
            c.width = c.field === 'clientName' ? 350 : c.width;
            return c;
        });

        const colWidth = calculateMinColumnWidths(columnArray.filter(c => c.show && !c.hidden), gridDivRef.current.offsetWidth, 'clientName', 350, true);
        setClientColumnWidth(colWidth);
        columnArray.find(c => c.id === 'clientColumn').width = colWidth;
        columnArray.find(c => c.actionCell).orderIndex = 1000;
        setColumns(columnArray);    

        const updatedDataState = { ...dataState };
        updatedDataState['columns'] = columnArray;
        setDataState(updatedDataState);

    };

    const renderColumnCell = field => {
        switch (field) {
            case 'clientName':
                return nameCell;
            case '':
                return actionsCell;
            case 'highFaultCount':
            case 'mediumFaultCount':
            case 'lowFaultCount':
                return priorityCell;
            case 'businessTypeName':
            case 'siteCount':
            case 'totalFaultCount':
                return dataCell;
            default:
                return null;
        }
    };

    const handleClose = () => {
        setShowModal(!showModal);
    };

    const createConditionalFormat = (props) => {
        let formats = [];
        if (formatObj[props.column.field]) {
            formats = formatObj[props.column.field];
        }
        if (props.column.field !== 'start') {
            let col = columns.filter(c => c.field === props.column.field);
            if (col && col.length > 0) {
                setFormatType(col[0].filter);
            }
        }
        else {
            setFormatType('date');
        }
        setFormatList(JSON.parse(JSON.stringify(formats)));
        setFormatKey(props.column.field);
        setShowModal(true);
    };

    const addCalculatedColumn = props => {
        setCurrentFormula(null);
        const colIndex = columns.find(c => c.field === props.column.field).orderIndex;
        if (!colIndex) {
            setFormulaColumnIndex(columns.length);
        }
        else {
            setFormulaColumnIndex(colIndex);
        }

        setFormulaCellModalOpen(true);
    };

    const editCalculatedColumn = props => {
        const editFormula = formulaColumns.find(f => f.fieldName === props.column.field);
        if (editFormula) {
            setCurrentFormula(editFormula);
            setFormulaCellModalOpen(true);
        }
    };

    const removeCalculatedColumn = props => {
        const updatedColumns = columns.filter(c => c.field !== props.column.field);
        updatedColumns.find(c => c.actionCell).orderIndex = 1000;
        setColumns(updatedColumns);

        const currentFormulaList = cloneDeep(formulaColumns);
        const updatedColumnList = currentFormulaList.filter(c => c.fieldName !== props.column.field);
        setFormulaColumns(updatedColumnList);
    };

    const addFormulaColumn = formula => {
        const currentFormulaList = cloneDeep(formulaColumns);
        const foundColumn = currentFormulaList.find(c => c.fieldName === formula.fieldName);
        if (!foundColumn) {
            const newFormulaList = [...currentFormulaList, formulaValues];
            setFormulaColumns(newFormulaList);
            const newColumn = {
                name:       formulaValues.cellTitle,
                title:      formulaValues.cellTitle,
                field:      formulaValues.fieldName,
                filter:     'numeric',
                format:     '{0:n}',
                isFormula:  true,
                orderIndex: formulaValues.cellIndex,
                show:       true,
                hidden:     false,
                width:      200
            };
            let columnList = [...columns];
            columnList.splice(columnList.length - 1, 0, newColumn);
            columnList.find(c => c.actionCell).orderIndex = 1000;
            setColumns(columnList);
        }
        else {
            const index = currentFormulaList.findIndex(c => c.fieldName === formula.fieldName);
            currentFormulaList[index] = formula;

            // grid columns
            try {
                columns.find(c => c.field === formula.fieldName).name = formula.cellTitle;
                columns.find(c => c.field === formula.fieldName).title = formula.cellTitle;
            }
            catch {
                // no need to do anything
            }

            setFormulaColumns(currentFormulaList);
        }

        const dataSet = addFormulaToGridDataSet(formulaValues, formulaValues.fieldName, tableData);
        setTableData(dataSet);
    };

    const addFormulaToGridDataSet = (formula, fieldName, gridData) => {
        const newDataSet = cloneDeep(gridData);
        let formulaResult = 0;
        newDataSet.map(data => {
            switch (formula.operator.operator) {
                case '+':
                    formulaResult = parseFloat(data[formula.columnOne.field]) + parseFloat(data[formula.columnTwo.field]);
                    break;
                case '-':
                    formulaResult = parseFloat(data[formula.columnOne.field]) - parseFloat(data[formula.columnTwo.field]);
                    break;
                case '*':
                    formulaResult = parseFloat(data[formula.columnOne.field]) * parseFloat(data[formula.columnTwo.field]);
                    break;
                case '/':
                    formulaResult = parseFloat(data[formula.columnOne.field]) / parseFloat(data[formula.columnTwo.field]);
                    break;
                default:
                    formulaResult = parseFloat(data[formula.columnOne.field]) + parseFloat(data[formula.columnTwo.field]);
                    break;
            }
            return data[formula.fieldName] = formulaResult.toFixed(formula.precision);
        });
        return newDataSet;
    };

    const updateUserView = async (obj, formulaValues) => {
        const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');
        if (tableConfiguration) {
            dataState.columns = columns;
            tableConfiguration.viewData = JSON.stringify({ 
                dataState:           dataState, 
                formatObj:           obj, 
                formulaValues:       formulaValues, 
                workbookModeEnabled: workbookModeEnabled,
                ownerId:             currentUser.id 
            });
            await updateConfiguration(tableConfiguration.id, tableConfiguration, true);
            updateCoreConfigurations(tableConfiguration.id, tableConfiguration);
        } else {
            let body = {
                name:         'Dashboard Company Client Table Configuration',
                viewKey:      'Dashboard|CompanyClientTable',
                entityId:     activeNavCompany.id,
                entityName:   activeNavCompany.name,
                isDefault:    false,
                viewData:     JSON.stringify({ dataState: { ...dataState, columns: columns }, formatObj: formatObj, formulaValues: formulaValues, ownerId: currentUser.id, workbookModeEnabled: workbookModeEnabled }),
                sharedEmails: []
            };
            const id = await saveConfiguration(userId, body, true);
            if (id) {
                body.id = id;
                let activeState = cloneDeep(body.viewData);
                body.viewData = JSON.parse(activeState);
                updateCoreConfigurations(id, body);
            }
        }
    };

    const onColumnReorder = async e => {
        const tempColumns = cloneDeep(columns).map(col => {
            const newCol = e.columns.find(c => c.field === col.field);
            if (newCol && !col.actionCell) {
                return {...col, orderIndex: newCol.orderIndex};
            }
            else {
                return col;
            }
        });
        orderBy(tempColumns, 'orderIndex', 'asc').filter(c => !c.actionCell).map((col, idx) => {
            col.orderIndex = idx;
            return col;
        });
        tempColumns.find(c => c.actionCell).orderIndex = 1000;
        setColumns(tempColumns);

        setHasInitialized(true);

        const tableConfiguration = configurations.find(item => item.viewKey === 'Dashboard|CompanyClientTable');

        if (tableConfiguration) {
            dataState.columns = tempColumns;
            tableConfiguration.viewData = JSON.stringify({ 
                dataState:           dataState, 
                formatObj:           formatObj, 
                formulaColumns:      formulaColumns, 
                ownerId:             currentUser.id,
                workbookModeEnabled: workbookModeEnabled
            });
            await updateConfiguration(tableConfiguration.id, tableConfiguration, true);
            updateCoreConfigurations(tableConfiguration.id, tableConfiguration);
        } else {
            let body = {
                name:       'Dashboard Company Client Table Configuration',
                viewKey:    'Dashboard|CompanyClientTable',
                entityId:   activeNavCompany.id,
                entityName: activeNavCompany.name,
                isDefault:  false,
                viewData:   JSON.stringify({ 
                    dataState: { 
                        ...dataState, 
                        columns:             tempColumns,
                        workbookModeEnabled: workbookModeEnabled 
                    }, 
                    formatObj:      formatObj, 
                    formulaColumns: formulaColumns, 
                    ownerId:        currentUser.id 
                }),
                sharedEmails: []
            };
            const id = await saveConfiguration(userId, body, true);
            if (id) {
                body.id = id;
                let activeState = cloneDeep(body.viewData);
                body.viewData = JSON.parse(activeState);
                updateCoreConfigurations(id, body);
            }
        }
    };

    const handleExport = event => {
        const options = _export.current.workbookOptions();
        const rows = options.sheets[0].rows;
        rows.forEach((row, rindex) => {
            if (row.type === 'data') {
                row.cells.forEach((cell, colindex) => {
                    formatDataCell(cell, colindex);
                });
            }
        });
        _export.current.save(options);
    };

    const formatDataCell = (cell, colindex) => {
        const field = columns[colindex].field;
        const conditions = formatObj[field];
        let _className = '';
        const datatype = columns[colindex].filter;
        if (conditions && cell.value !== null && cell.value !== '' && cell.value !== undefined) {
            _className = parseCondition(conditions, cell.value, datatype);
        }
        if (_className) {
            cell.background = styleMap[_className].background;
            cell.color = styleMap[_className].color;
        }
        if (datatype === 'numeric') {
            cell.format = '#,###,##0.##########';
        }
    };

    const clearGridFilter = filter => {
        setDataState({...dataState, filter: filter ? filter : initialDataStateFilter});
    };

    return (
        <React.Fragment>
            <style>
                {kendoGridInlineStyling}
                {
                    `.k-toolbar {
                            order: 1;
                            border-top: inset 1px rgba(0, 0, 0, 0.12);
                            max-height: 5.8rem;
                    }
                    `
                }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <ExcelExport data={kendoProcess(tableData, dataState).data} ref={_export}>
                    {
                        orderBy(columns, ['orderIndex'], ['asc']).map((column, index) =>
                            column.show && !column.hidden && (
                                <ExcelExportColumn
                                    key={index}
                                    field={column.field}
                                    title={column.name}
                                    filter={column.filter}
                                    locked={column.locked ? column.locked : false}
                                />
                            )
                        )
                    }
                </ExcelExport>
                <Grid
                    ref={gridRef} 
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(tableData, dataState)}
                    {...dataState}
                    pageable={pageable}
                    reorderable
                    filterable={workbookModeEnabled}
                    onDataStateChange={onDataStateChange}
                    onColumnReorder={onColumnReorder}
                >
                    {
                        workbookModeEnabled ?
                            <GridToolbar>
                                <FilterPanel
                                    title={'Client Filter Builder'}
                                    filter={dataState.filter}
                                    filterText={gridFilterText}
                                    fields={gridFields}
                                    columns={columns}
                                    setFilter={clearGridFilter}
                                    setFilterText={setGridFilterText}
                                />
                            </GridToolbar>
                            : null
                    }
                    {
                        bobLoading.includes('CompanyClient') || isEmpty(clientsMeta) ?
                            <GridNoRecords>
                                Loading clients
                            </GridNoRecords>
                            :
                            null
                    }
                    {
                        orderBy(columns, ['orderIndex'], ['asc']).map(
                            (column, index) => 
                                ((column.show && !column.hidden) || column.actionCell) && (
                                    <Column
                                        key={index}
                                        field={column.field}
                                        title={column.title}
                                        id={column.id}
                                        cell={renderColumnCell(column.field)}
                                        width={column.id === 'clientColumn' ? clientColumnWidth : column.width}
                                        filter={column.filter}
                                        filterCell={column.filterCell}
                                        sortable={column.sortable}
                                        filterable={column.filterable}
                                        locked={column.locked}
                                        reorderable={column.reorderable}
                                        orderIndex={column.orderIndex}
                                        columnMenu={column.field ?
                                            (props) => (
                                                <ColumnFilterMenu
                                                    {...props}
                                                    isFormula={column.isFormula}
                                                    addCalculatedColumn={addCalculatedColumn}
                                                    allowFiltering={false}
                                                    allowFormatting={true}
                                                    allowFormula={true}
                                                    columns={columns}
                                                    createConditionalFormat={createConditionalFormat}
                                                    editCalculatedColumn={editCalculatedColumn}
                                                    formatObj={formatObj}
                                                    removeCalculatedColumn={removeCalculatedColumn}
                                                    setFormatObj={setFormatObj}
                                                    setFormatList={setFormatList}
                                                    updateColumns={updateColumns}
                                                    updateUserView={updateUserView}
                                                />
                                            )
                                            :
                                            null
                                        }
                                    />
                                )
                        )
                    }
                </Grid>
                {
                    showModal ?
                        <BobConditionalFormattingModal
                            open={showModal}
                            close={handleClose}
                            formatList={formatList}
                            formatKey={formatKey}
                            formatType={formatType}
                            setFormatList={setFormatList}
                            formatObj={formatObj}
                            setFormatObj={setFormatObj}
                            updateUserView={updateUserView}
                        />
                        :
                        null
                }
                {
                    formulaCellModalOpen ?
                        <FormulaGridColumnModal
                            cellIndex={formulaColumnIndex}
                            columnList={columns.filter(c => c.filter === 'numeric')}
                            formula={currentFormula}
                            setFormulaFormIsOpen={setFormulaCellModalOpen}
                            setFormulaValues={setFormulaValues}
                            title={currentFormula ? 'Edit Formula' : 'Create Formula'}
                        />
                        :
                        null
                }
                {
                    subscribeToAlertsModalOpen ?
                        <CreateSubscriptionModal
                            parent={client}
                            parentLabel="Client"
                            handleToggleSubscribeToAlertsModal={handleToggleSubscribeToAlertsModal}
                        />
                        :
                        null
                }
                {
                    createClientModalOpen ?
                        <BobModal
                            title={'Add New Client'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => handleToggleCreateClientModal(false)}
                        >
                            <CreateClientModal
                                fetchClients={(body) => fetchClients(body)}
                                onClose={() => handleToggleCreateClientModal(false)}
                            />
                        </BobModal> : ''
                }
                {
                    editClientModalOpen ?
                        <BobModal
                            title={'Edit Client'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => handleToggleEditClientModal(false)}
                        >
                            <EditClientModal
                                client={client}
                                fetchClients={fetchUpdatedClientList}
                                onClose={() => handleToggleEditClientModal(false)}
                            />
                        </BobModal> : ''
                }
                {
                    deleteClientModalOpen ?
                        <BobModal
                            title={'Delete Entity'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => handleToggleDeleteClientModal(false)}
                        >
                            <DeleteClientModal
                                client={client}
                                fetchClients={fetchUpdatedClientList}
                                onClose={() => handleToggleDeleteClientModal(false)}
                            />
                        </BobModal> : ''
                }
                {
                    bobLoading.includes('CompanyClient') || isEmpty(clientsMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

ClientsTable.defaultProps = {
    clients: []
};

ClientsTable.propTypes = {
    clients: array
};

const mapStateToProps = state => ({
    activeNavCompany:            state.bob.activeNavCompany,
    bobLoading:                  state.bob.bobLoading,
    clientFilters:               state.dashboard.clientFilters,
    clients:                     state.dashboard.clients,
    clientsMeta:                 state.dashboard.clientsMeta,
    configurations:              state.configurationData.allConfigurations,
    currentUser:                 state.currentUser,
    customAttributes:            state.attributeManagement.customAttributes,
    companies:                   state.core.companies,
    companyTabIndex:             state.dashboard.companyTabIndex,
    dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
    dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    targetNavCompany:            state.bob.targetNavCompany,
    userId:                      state.currentUser.id,
});

const mapDispatchToProps = ({
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientsTable));
